import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgChevronDown = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={46} height={46} fill="none" viewBox="0 0 46 46" {...props}><Path fill="currentColor" fillRule="evenodd" d="m.007 13.654 23 22.846 23-22.846L41.826 9.5 23.006 28.192 4.19 9.5.007 13.654Z" clipRule="evenodd" /></Svg>;
const Memo = memo(SvgChevronDown);
export default Memo;